import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/credit-customer-list',
            name: 'admin-credit-customer-list',
            component: () => import(/* webpackChunkName: "page-admin-credit-management-credit-customer-list" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "授信客户"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "授信管理"
                                        },
                                        {
                                                  name: "授信客户"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
